import { Button, IconButton } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch } from 'react-redux';
import CustomCheckbox from '../../../../../shared/form-controls/custom-checkbox/Custom-Checkbox';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import KeyValuePairList from '../../../../../shared/key-value-pair-list/KeyValuePairList';
import { formDataValidate } from '../../../../../utils/formUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import {
  createHotelRateFilter,
  updateHotelRateFilter,
} from '../../../../../utils/ServicesAPIUtils';
import { fetchAllAccommodations } from '../../../../property/propertySlice';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const RateFiltersCreate = (props) => {
  const dispatch = useDispatch();
  const { toggleDrawer, rateFilter, hotelId, showLoader = () => {} } = props;
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    name: {
      value: '',
      fieldName: 'Rate Filter Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    code: {
      value: '',
      fieldName: 'Rate Filter Code',
      errors: {},
      validations: ['required', 'validAlphaNumeric'],
      tab: 0,
    },
    description: {
      value: '',
      fieldName: 'Description',
      errors: {},
      validations: [],
      tab: 0,
    },
    customAttributes: {
      value: [],
      fieldName: 'Custom Attributes',
      errors: {},
      validations: [],
      tab: 0,
    },
    displayName: {
      value: '',
      fieldName: 'Display Name',
      errors: {},
      validations: [],
      tab: 0,
    },
    rateCodes: {
      value: '',
      fieldName: 'Rate Codes',
      errors: {},
      validations: [],
      tab: 0,
    },
    rateCodeDescription: {
      value: '',
      fieldName: 'Rate Code Description',
      errors: {},
      validations: [],
      tab: 0,
    },
    isActive: {
      value: true,
      selected: true,
      fieldName: 'Active',
      errors: {},
      validations: [],
      tab: 0,
    },
  });

  const CustomToolTip = withStyles({
    tooltip: {
      color: 'white',
      backgroundColor: 'black',
    },
  })(Tooltip);

  useEffect(() => {
    if (rateFilter) {
      console.log(rateFilter);
      const currFields = { ...formData };
      currFields.code.value = rateFilter.code;
      currFields.displayName.value = rateFilter.displayName;
      currFields.description.value = rateFilter.description;
      currFields.isActive.value = rateFilter.isActive;
      currFields.name.value = rateFilter.name;
      currFields.customAttributes.value = rateFilter.customAttributes || [];
      currFields.rateCodeDescription.value = rateFilter.rateCodeDescription;
      currFields.rateCodes.value = rateFilter.rateCodes;
      setFormData(currFields);
    }
  }, [rateFilter]);

  const validate = () => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const handleSubmit = async (e) => {
    console.log(formData);
    e.preventDefault();
    if (validate()) {
      try {
        dispatch(stepUpLoaderCount());
        toggleDrawer('', false, '');
        const selectedLanguage = decryptLocalStorage('lang');
        const language = selectedLanguage !== 'en' ? selectedLanguage : '';
        if (rateFilter) {
          const payload = {
            code: formData.code.value,
            displayName: formData.displayName.value,
            description: formData.description.value,
            isActive: formData.isActive.value,
            name: formData.name.value,
            customAttributes: formData.customAttributes.value,
            rateCodeDescription: formData.rateCodeDescription.value,
            rateCodes: formData.rateCodes.value,
            id: rateFilter.id,
          };
          await updateHotelRateFilter(hotelId, payload, language);
          notificationManager('success', 'Rate filter updated successfully');
        } else {
          const payload = {
            code: formData.code.value,
            displayName: formData.displayName.value,
            description: formData.description.value,
            isActive: formData.isActive.value,
            name: formData.name.value,
            customAttributes: formData.customAttributes.value,
            rateCodeDescription: formData.rateCodeDescription.value,
            rateCodes: formData.rateCodes.value,
          };
          await createHotelRateFilter(hotelId, payload, language);
          notificationManager('success', 'Rate filter created successfully');
        }
        dispatch(fetchAllAccommodations(hotelId));
      } catch (error) {
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          rateFilter
            ? notificationManager('danger', 'Rate filter updation failed')
            : notificationManager('danger', 'Rate filter creation failed');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  useEffect(() => {
    const isValid = formDataValidate(formData, false);
    setIsTabInValid(!isValid);
  }, [formData]);

  return (
    <form className='roomtype-create' noValidate onSubmit={handleSubmit}>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-6'>
            <span className='page-title'>
              {rateFilter ? 'Edit Rate Filter' : 'Add Rate Filter'}
            </span>
          </div>
          <div className='col-md-6 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
          <div className='row px-3 w-100 mt-3 mb-2'>
            <div className='col-md-12'>
              <span className='page-title-secondary'>Details</span>
            </div>
          </div>
          <div className='row px-3 w-100 d-flex mt-2'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.name}
                handleInputChange={(e) => {
                  setFormData({ name: e });
                }}
                maxLength={100}
                endAdornment={true}
                characterCount={true}
                multiline={true}
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.code}
                handleInputChange={(e) => {
                  setFormData({ code: e });
                }}
                maxLength={30}
                endAdornment={true}
                characterCount={true}
              />
            </div>
          </div>
          <div className='row px-3 w-100 d-flex mt-2'>
            <div className='col-md-12 mb-3'>
              <CustomTextField
                item={formData.description}
                handleInputChange={(e) => {
                  setFormData({ description: e });
                }}
                multiline={true}
              />
            </div>
          </div>
          <div className='row px-3 w-100 d-flex mt-2'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.displayName}
                handleInputChange={(e) => {
                  setFormData({ displayName: e });
                }}
                multiline={true}
                maxLength={50}
                endAdornment={true}
                characterCount={true}
              />
            </div>
            <div className='col-md-6 mt-3'>
              <CustomCheckbox
                item={formData.isActive}
                handleInputChange={(e) => {
                  setFormData({ isActive: e });
                }}
                color='primary'
              />
            </div>
          </div>
          <div className='row px-3 w-100 d-flex  mt-2'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.rateCodes}
                handleInputChange={(e) => {
                  setFormData({ rateCodes: e });
                }}
                multiline={true}
                maxLength={50}
                endAdornment={true}
                characterCount={true}
              />
            </div>
            <div className='col-md-6 mt-3'>
              <div className='info-icon col-md-2'>
                <CustomToolTip
                  title='Add multiple rate codes by separating them with comma.'
                  placement='right-end'
                >
                  <InfoIcon />
                </CustomToolTip>
              </div>
            </div>
          </div>
          <div className='row px-3 w-100 d-flex mt-2'>
            <div className='col-md-12 mb-3'>
              <CustomTextField
                item={formData.rateCodeDescription}
                handleInputChange={(e) => {
                  setFormData({ rateCodeDescription: e });
                }}
                multiline={true}
              />
            </div>
          </div>
          <div className='row px-3 w-100 mt-4'>
            <KeyValuePairList
              item={formData.customAttributes}
              onListChange={(e) => {
                setFormData({ customAttributes: e });
              }}
            />
          </div>
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            <Button
              variant='contained'
              type='submit'
              color='primary'
              className='me-3'
              size='large'
              disabled={isTabInValid}
            >
              {rateFilter ? 'Update' : 'Add'}
            </Button>
            <Button
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default RateFiltersCreate;
